import * as Yup from 'yup'


/** Reject Seller Market Product schema */
const sellerMarketProductRejectFormSchema = Yup.object().shape({
  reject_reason : Yup.string().required('Required'),
  reject_note   : Yup.string()
})

export default sellerMarketProductRejectFormSchema
